import { useQuery, skipToken } from '@tanstack/react-query';
import type { UserDeliveriesResponse } from '@citibox-panel/api-client';

export interface UseUserDeliveries {
  data: UserDeliveriesResponse | undefined;
  isPending: boolean;
  isError: boolean;
}

// Recent deliveries, keyed by the numeric USER ID. The query is skipped (skipToken)
// until the account resolves the id. The error is left as inline state (default
// throwOnError: false): a deliveries failure must be reported by the section alone — the floating
// notice of ADR 0021 — never tear down the «Usuario» ficha next to it via the shell boundary.
// No `refetch`: the notice carries no action and nothing in the section offers one either, so the
// list reloads by remounting. Exposing one again would be re-adding the retry through the hook.
export function useUserDeliveries(
  id: string | undefined,
  fetchDeliveries: (id: string) => Promise<UserDeliveriesResponse>,
): UseUserDeliveries {
  const { data, isPending, isError } = useQuery({
    queryKey: ['user-deliveries', id],
    queryFn: id === undefined ? skipToken : () => fetchDeliveries(id),
  });

  return { data, isPending, isError };
}
